const validateCitizenshipStep = (values) => {
  const errors = {};
  if (values.isUsCitizenOrResident === undefined) {
    errors.isUsCitizenOrResident = 'Citizenship status is required.';
  }

  return errors;
};
export default validateCitizenshipStep;
